import React, { useEffect } from 'react';
import './../../../core/style/Toast.css';

const Toast = ({ show, type, title, message, onClose, duration = 4000 }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration, onClose]);

  if (!show) return null;

  return (
    <div className={`global-toast-container toast-${type}`}>
      <div className="toast-badge">
        {type === 'success' ? '✓' : '✕'}
      </div>
      <div className="toast-text-content">
        <h4>{title}</h4>
        <p>{message}</p>
      </div>
      <button className="toast-close-btn" onClick={onClose}>×</button>
    </div>
  );
};

export default Toast;